import { COUPON_TYPES } from '../../constants'
import { getItemPosPriceIndex, getItemPosPrices, getPosPriceByIndex, getPosPriceTitle, getPosPriceValue, recalculateSubItems } from '../../../../../helper'
import { convert2CouponResultItem } from '../index'

export const convert2CashDeskResultItem = (item, orderType, currencySymbol) => {
	if (item.type === 'MARKETING_COUPON') {
		return convert2CouponResultItem(item, currencySymbol)
	} else {
		return item?.initialProduct ? convertCashDeskItem2CartItem(item, orderType) : recalculateSubItems(item)
	}
}

export const convertCashDeskItem2CartItem = (item, orderType) => {
	const { initialProduct: product, quantity, items, remark, priceTitleId, discountInfo } = item
	const priceTitle = getPosPriceTitle(product, orderType, priceTitleId)
	const priceIndex = getItemPosPriceIndex(product, orderType, priceTitleId)
	const subItems = product.productType === 'MENU' ?
		items.map(subItm => convertCashDeskItem2CartItem(subItm, orderType)) :
		items?.map(subItm => {
			const subPriceIndex = getItemPosPriceIndex(subItm.initialProduct, orderType, subItm.priceTitleId)
			const subItmPrice = getPosPriceByIndex(subItm.initialProduct, orderType, subPriceIndex)
			const subItmPriceValue = subItmPrice.value
			const subItmPriceTitleId = subItmPrice.priceTitle.id
			return ({
				itemId: subItm.initialProduct.productId,
				type: subItm.initialProduct.productType,
				sku: subItm.initialProduct.nr,
				category: subItm.initialProduct.category?.title,
				quantity: subItm.quantity,
				name: subItm.initialProduct.title,
				price: subItmPriceValue,
				initialPrice: subItmPriceValue,
				remark: subItm.remark,
				priceIndex,
				priceTitleId: subItmPriceTitleId,
				disabledDiscount: subItm.initialProduct.category?.disabledDiscount || subItm.initialProduct.disabledDiscount,
				toppingGroupId: subItm?.toppingGroupId,
			})
		})

	return recalculateSubItems({
		itemId: product.productId,
		type: product.productType,
		sku: product.nr,
		category: product.category?.title,
		quantity,
		name: product.title + (priceTitle ? ' ' + priceTitle : ''),
		price: item.extraPrice !== undefined && !item.withOriginalPrice ? item.extraPrice : getPosPriceValue(product, orderType, priceTitleId),
		initialPrice: getPosPriceValue(product, orderType, priceTitleId),
		remark,
		priceIndex,
		items: subItems,
		ingredients: product?.ingredients,
		numberOfMustExtras: product.numberOfMustExtras,
		freeExtrasNumber: product.freeExtrasNumber,
		mustExtras: product.mustExtras,
		inMinimumOrderValueConsidered: product.inMinimumOrderValueConsidered,
		disabledDiscount: product.category?.disabledDiscount || product.disabledDiscount,
		originalPrice: item.withOriginalPrice,
		discountInfo
	})
}

export const isItemPriceDisabled = (item, orderType) => {
	const itemInitialProduct = item?.initialProduct
	if (!itemInitialProduct) return false

	if (itemInitialProduct?.productType === 'MENU') {
		const disablePriceInItemMenu = !getItemPosPrices(item, orderType)?.length
		const disablePriceInItemMenuProduct = item.items?.some(it => !getItemPosPrices(it, orderType)?.some(t => t.priceTitle.id === it.priceTitleId))
		const disablePriceInItemMenuProductTopping = item.items?.reduce((acc, it) => acc || it?.items?.some(tt => !getItemPosPrices(tt, orderType)?.some(t => t.priceTitle.id === tt.priceTitleId)), false)
		return disablePriceInItemMenu || disablePriceInItemMenuProduct || disablePriceInItemMenuProductTopping
	} else {
		const disabledPriceInItemSize = !getItemPosPrices(item, orderType)?.some(it => it.priceTitle.id === item.priceTitleId)
		const disablePriceInItemTopping = item.items?.some(it => !getItemPosPrices(it, orderType)?.some(t => t.priceTitle.id === it.priceTitleId))
		return disabledPriceInItemSize || disablePriceInItemTopping
	}
}

export const compareCartItems = (a, b) => {
	if (a.disabled === b.disabled) return 0
	return a.disabled ? 1 : -1
}

export const convert2CashDeskItem = (item, isMenuItem = false) => {
	if (COUPON_TYPES.includes(item.type) || item.itemId === 'custom') return item

	const items = item.items
	const subItems = item.type === 'MENU' ?
		items.map(subItm => convert2CashDeskItem(subItm, true)) :
		items?.map(subItm => ({
			initialProduct: subItm.initialProduct,
			priceTitleId: subItm.priceTitleId,
			quantity: subItm.quantity,
			remark: subItm.remark,
			type: subItm.type,
			itemId: subItm.itemId,
			toppingGroupId: subItm?.toppingGroupId,
		}))

	const cashDeskItem = {
		initialProduct: item.initialProduct,
		priceTitleId: item.priceTitleId,
		quantity: item.quantity,
		items: subItems,
		remark: item.remark,
		type: item.type,
		itemId: item.itemId,
		...(!isMenuItem && item?.type !== 'TOPPING' && {
			discountInfo: item.discountInfo || null
		})
	}

	return isMenuItem ? {
			...cashDeskItem,
			extraPrice: item.extraPrice,
			withOriginalPrice: item.withOriginalPrice,
		} : cashDeskItem
}
